module.exports = __webpack_public_path__ + "img/img41.d407f588.svg";